<template>
  <div class="wrapper">
    <top-bar :state="state"></top-bar>
    <sidebar></sidebar>
    <control-sidebar :state="state"></control-sidebar>
    <div class="content-wrapper" @click="focusHandler">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <template v-for="alert in alerts">
          <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
            <h4>
              <i :class="alert.icon"></i>
              {{`alert_${alert.type}` | translate}}!</h4>
            {{alert.message}}
          </b-alert>
        </template>
        <template>
          <h1 class="pageTitle">{{translate($route && $route.name) || $route.name}}</h1>
        </template>
        <ol class="breadcrumb">
          <template v-for="path in pathsGenerator()">
            <li class="active">{{translate(path) || path | capitalize}}</li>
          </template>
        </ol>
      </section>
      <div class="alertRow">
        <template v-for="alert in alerts">
          <div :class="['alert', `alert-${alert.type}`, 'alert-dismissible']">
            <button type="button" class="close" data-dismiss="alert" aria-hidden="true" @click="alerts.splice(alerts.indexOf(alert), 1)">×</button>
            <h4><i :class="`icon ${alert.icon} mr-5`"></i>{{alert.type | translate | capitalize}}!</h4>
            {{alert.message}}
          </div>
        </template>
      </div>
      <router-view></router-view>
    </div>
    <!--<footer class="main-footer">
      <strong>Copyright &copy; {{year}} <a href="javascript:;">ANWR Media</a>.</strong> All rights reserved.
    </footer>-->
  </div>
  <!-- ./wrapper -->
</template>

<script>
import {bus} from '../main'
export default {
  name: 'Home',
  data () {
    return {
      processing: {
        line: false,
        mp: false
      },
      ordersCount: 0,
      alerts: [],
      parcelOptions: '',
      stores: '',
      section: 'Dash',
      me: '',
      error: '',
      goto: '',
      gotoLine: '',
      gotoMP: '',
      ccCount: 0,
      state: this.$store.state,
      translate (word) {
        let trans = this.$options.filters.translate(word, this.language)
        if (trans === 'undefined') {
          return false
        } else {
          return trans
        }
      },
      language: this.$store.getters.language
    }
  },
  computed: {
    classObject () {
      return 'pageLink'
    },
    year () {
      let y = new Date()
      return y.getFullYear()
    }
  },
  methods: {
    pathsGenerator () {
      let paths = this.$route.path.split('/')
      paths.shift()
      return paths
    },
    checkEnv () {
      return ['qb-schuhe.de', 'qualibet-schuhe.de', 'qbschuhe.de', 'www.qb-schuhe.de', 'www.qualibet-schuhe.de', 'www.qbschuhe.de', 'myplace.schuhe.de'].indexOf(window.location.hostname) !== -1
    },
    focusHandler () {
      if (this.$store.state.sidebarOpen)
      {
        this.$store.commit('toggleSidebar')
      }
    }
  },
  created () {
    bus.$on('emitAlert', (data) => {
      this.alerts.push(data)
    })
    bus.$on('clearAlerts', (data) => {
      this.alerts = []
    })
  },
  mounted () {
    this.user = this.$store.getters.user
  }
}
</script>
<style scoped>
  .alertRow {
    padding: 0 30px 0px 30px;
    margin-right: auto;
    margin-left: auto;
  }
  .staging {
    background-color: #5b4094 !important;
  }
  .dev {
    background-color: #136178 !important;
  }
  .logo-st{
    width: 70%;
    -webkit-animation:spin 4s linear infinite;
    -moz-animation:spin 4s linear infinite;
    animation:spin 4s linear infinite;
    height: 50px !important;
  }
  @-moz-keyframes spin { 100% { -moz-transform: rotateY(360deg); } }
  @-webkit-keyframes spin { 100% { -webkit-transform: rotateY(360deg); } }
  @keyframes spin { 100% { -webkit-transform: rotateY(360deg); transform:rotateY(360deg); } }
</style>
